import { Grid } from "@mui/material";
import { handleCampaignLimitUnit } from "components/Layout/Campaign/utils/utils";
import { useMessage } from "hooks/intl";
import { isEmpty, isUndefined } from "lodash";
import { BEAchievementLimit } from "types/achievements";
import { formatNumberValue } from "utilities/numbers";
import { useStyles } from "./SingleAchievement.styles";

interface Props {
  achievementData?: { limit?: BEAchievementLimit };
}

export const AchievementLimit = (limit: BEAchievementLimit) => {
  const { message } = useMessage();

  if (!limit || isEmpty(limit)) {
    return message({ id: "unlimited" });
  } else if ("interval" in limit) {
    return `${formatNumberValue(limit.value)} ${message({
      id: handleCampaignLimitUnit(limit?.interval?.type),
    }).toLowerCase()}`;
  } else if ("value" in limit) {
    return `${formatNumberValue(limit.value)} ${message({
      id: "inTotal",
    }).toLowerCase()}`;
  }
};

export const Limit = ({ achievementData }: Props) => {
  const classes = useStyles();
  const { message } = useMessage();

  const limit = [
    {
      left: "achievementReachLimitMemberBased",
      leftDataTestId: "achievement-reach-limit-member-based-label",
      right: <AchievementLimit {...achievementData?.limit} />,
      rightDataTestId: "achievement-reach-limit-member-based-value",
    },
  ];

  return (
    <>
      <Grid container className={classes.gridContainer}>
        <Grid className={classes.gridChild} item xs={12}>
          <span className={classes.header}>{message({ id: "limit" })}</span>
          {limit.map((row) => (
            <span className={classes.content} key={row.left}>
              <span className={classes.left} data-test-id={row.leftDataTestId}>
                {message({ id: row.left })}
              </span>
              <span
                className={classes.right}
                data-test-id={row.rightDataTestId}
              >
                {isUndefined(row.right) ? "-" : row.right}
              </span>
            </span>
          ))}
        </Grid>
      </Grid>
    </>
  );
};
